<template>
  <div class="v--modal-header">
    <h5>
      {{ modalNameProp }}
  
      <span class="box-name-info" @click="tooltip = true" :class="{ 'blue-box-info': tooltip}" v-if="infoTooltip"></span>
      <f-p-tooltip
          v-if="tooltip"
          v-click-outside="hideTooltip"
          :hideTooltipInside="hideTooltip"
          :tooltipTitle="infoTooltipTitle"
          :tooltipContent="infoTooltipText">
      </f-p-tooltip>
    </h5>
    
    <span @click="hideModalProp()" class="v--modal-close-span">×</span>
  </div>
</template>

<script>
  import vClickOutside from 'v-click-outside';
  
  export default {
    name: "ModalsHeader",
    components: {
      'f-p-tooltip': () => import('@/components/common/FPTooltip'),
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    props: {
      modalNameProp: {
        type: String,
        required: true,
        default: () => {
          return '';
        }
      },
      infoTooltip: {
        type: Boolean,
        required: false,
        default: () => {
          return false;
        }
      },
      infoTooltipTitle: {
        type: String,
        required: false,
        default: () => {
          return '';
        }
      },
      infoTooltipText: {
        type: String,
        required: false,
        default: () => {
          return '';
        }
      }
    },
    data() {
      return {
        tooltip: false
      }
    },
    methods: {
      hideModalProp() {
        this.$emit('hideModalProp')
      },
      hideTooltip() {
        this.$emit('hideTooltip')
      },
    }
  }
</script>
